import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

import { RouteSearchEntity } from '../../schedule.model';

@Injectable()
export class RouteSearchActions {
    static SET_ROUTE_SEARCH_DATA = '[Schedule]: Set route search data';
    static SET_PREVIOUS_SEARCH = '[Schedule]: Set previous search';
    static SET_PREVIOUS_SEARCH_SUCCESS = '[Schedule]: Set previous search successful';

    setRouteSearchData(data: RouteSearchEntity): RidangoReduxAction {
        return {
            type: RouteSearchActions.SET_ROUTE_SEARCH_DATA,
            payload: data,
        };
    }

    setPreviousSearch(data: any) {
        return {
            type: RouteSearchActions.SET_PREVIOUS_SEARCH,
            payload: data,
        };
    }
}
